"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _newComponents = require("../../new-components");
var UpdatePaymentCard = function UpdatePaymentCard(_ref) {
  var cardLogoName = _ref.cardLogoName,
    last4 = _ref.last4,
    expiryMonth = _ref.expiryMonth,
    expiryYear = _ref.expiryYear,
    useAnotherCard = _ref.useAnotherCard;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "d8-u-component-padding d8-u-radius-md border width-100% margin-top-lg margin-bottom-lg"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "margin-top-0 margin-bottom-0 flex items-center justify-between"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex flex-center"
  }, /*#__PURE__*/_react["default"].createElement(_newComponents.Svg, {
    name: cardLogoName && cardLogoName,
    className: "margin-right-sm"
  }), /*#__PURE__*/_react["default"].createElement("span", {
    className: "margin-right-sm"
  }, "**** ", last4)), /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex flex-center"
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: "d8-u-color-contrast-medium d8-u-text-semi-bold text-sm margin-right-md"
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: "hidden inline-block@sm"
  }, "Expiry "), " ", expiryMonth, " / ", expiryYear.toString().slice(-2)), /*#__PURE__*/_react["default"].createElement(_newComponents.Button, {
    className: "d8-u-color-error d8-u-text-semi-bold",
    style: {
      fontWeight: '400'
    },
    text: "Remove",
    buttonType: _newComponents.BUTTON_TYPES.NO_STYLE,
    buttonSize: _newComponents.BUTTON_SIZES.SMALL,
    onClick: useAnotherCard
  }))));
};
UpdatePaymentCard.propTypes = {
  cardLogoName: _propTypes["default"].string,
  last4: _propTypes["default"].string,
  expiryMonth: _propTypes["default"].number,
  expiryYear: _propTypes["default"].number,
  useAnotherCard: _propTypes["default"].func
};
var _default = exports["default"] = UpdatePaymentCard;